import { styled } from '@mui/material/styles';
import Accordion, { AccordionProps } from '@mui/material/Accordion';
import { blue } from '../../../theme/colors';
import { FC } from 'react';

const StyledAccordion = styled(Accordion, {
  skipSx: false,
  shouldForwardProp: (prop) => prop !== 'borderColor',
})<{ borderColor: string }>(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ({ theme, borderColor = blue[50] }) => ({
    borderTop: `1px solid ${borderColor}`,
    padding: theme.spacing(0, 2, 0, 2),
    '&.Mui-expanded': {
      margin: 0,
    },
    '&:before': {
      backgroundColor: borderColor,
    },
  }),
);

export const AccordionItem: FC<AccordionProps & { borderColor: string }> = ({
  className,
  ...restProps
}) => <StyledAccordion className={className} elevation={0} {...restProps} />;
